import { useState } from 'react';
import { useResendVerification } from '../../api/auth';
import { useAuth } from '../../auth/AuthContext';

/**
 * Soft-gate reminder: nothing in the app is blocked by an unverified email,
 * this just nudges the owner to confirm it. Shown on every authenticated
 * page until `user.emailVerifiedAt` is set (see AppLayout).
 */
export function EmailVerificationBanner() {
  const { user } = useAuth();
  const resend = useResendVerification();
  const [sent, setSent] = useState(false);

  if (!user || user.emailVerifiedAt) return null;

  return (
    <div className="ne-verify-banner" role="status">
      <span>
        {sent
          ? 'Verification email sent - check your inbox.'
          : `Please verify your email (${user.email}) to keep full access to your account.`}
      </span>
      {!sent ? (
        <button
          type="button"
          className="ne-verify-banner__action"
          disabled={resend.isPending}
          onClick={() => resend.mutate(undefined, { onSuccess: () => setSent(true) })}
        >
          {resend.isPending ? 'Sending…' : 'Resend email'}
        </button>
      ) : null}
    </div>
  );
}
